import React from "react";
import Header from "../../components/common/Header";
import Navbar from "../../components/common/Navbar";
import { MENU, SIDEBAR_OPTIONS } from "../../shared/enums/client_enum";

function AllFollowups() {
  return (
    <div>
      <Header />
      <Navbar menu={MENU}></Navbar>
    </div>
  );
}

export default AllFollowups;
